import React from 'react';
import styled from 'styled-components';

const StyledErrorMessage = styled.div`
  color: #f50057;
  font-size: 12px;
  margin-bottom: 4px;
`;

export const InputErrorMessage: React.FC = props => {
  return <StyledErrorMessage>{props.children}</StyledErrorMessage>;
};
